export const size_of_nodes = {
    small: { heightNode: 30, lineBlock: '30px', rowWrapper: '30px' },
    normal: { heightNode: 50, lineBlock: '50px', rowWrapper: '50px' },
    big: { heightNode: 70, lineBlock: '70px', rowWrapper: '70px' },
};
